// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.3-next',
  revision: '73f0da613',
  branch: 'next',
  date: 'Mon, 15 Jun 2026 11:13:13 GMT'
};